// Status dot + badge for customer activity state
export default function CustomerStatusBadge({ daysOverdue = 0, daysSinceOrder }) {
  if (daysOverdue > 0) {
    return (
      <span className="flex items-center gap-1 text-xs font-semibold text-red-600 bg-red-50 px-2 py-0.5 rounded-full border border-red-200">
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 inline-block" />
        متأخر
      </span>
    );
  }
  if (!daysSinceOrder && daysSinceOrder !== 0) {
    return (
      <span className="flex items-center gap-1 text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 inline-block" />
        جديد
      </span>
    );
  }
  if (daysSinceOrder > 30) {
    return (
      <span className="flex items-center gap-1 text-xs font-semibold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full border border-amber-200">
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500 inline-block" />
        غير نشط
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1 text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-200">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block animate-pulse inline-block" />
      نشط
    </span>
  );
}